import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { CartModal } from './components/CartModal';
import { CartProvider } from './context/CartContext';
import { Home } from './pages/Home';
import { Catalog } from './pages/Catalog';
import { ProductDetail } from './pages/ProductDetail';
import { Checkout } from './pages/Checkout';
import { Success } from './pages/Success';
import { Services } from './pages/Services';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <Router data-id="element-0">
      <CartProvider data-id="element-1">
        <div className="flex flex-col min-h-screen font-sans text-[#333333]" data-id="element-2">
          <ScrollToTop data-id="element-3" />
          <Navbar data-id="element-4" />
          <CartModal data-id="element-5" />
          <main className="flex-grow" data-id="element-6">
            <Routes data-id="element-7">
              <Route path="/" element={<Home data-id="element-9" />} data-id="element-8" />
              <Route path="/catalogo" element={<Catalog data-id="element-11" />} data-id="element-10" />
              <Route path="/producto/:id" element={<ProductDetail data-id="element-13" />} data-id="element-12" />
              <Route path="/checkout" element={<Checkout data-id="element-15" />} data-id="element-14" />
              <Route path="/success" element={<Success data-id="element-17" />} data-id="element-16" />
              <Route path="/servicios" element={<Services data-id="element-19" />} data-id="element-18" />
              <Route path="/nosotros" element={<About data-id="element-21" />} data-id="element-20" />
              <Route path="/contacto" element={<Contact data-id="element-23" />} data-id="element-22" />
            </Routes>
          </main>
          <Footer data-id="element-24" />
        </div>
      </CartProvider>
    </Router>;
}